/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Pricing from '../components/Pricing';
import NavBar from '../components/NavBar';

export const PricingPageTemplate = ({
                                        title,
                                        meta_title,
                                        meta_description,
                                        pricing,
                                    }) => (
    <div>
        <Helmet>
            <title>{meta_title}</title>
            <meta name="description" content={meta_description}/>
        </Helmet>
        <NavBar/>
        <section className="hero is-primary is-bold">
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-10 is-offset-1">
                            <div className="section">
                                <h1 className="title">
                                    {title}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section className="section section--gradient">
            <div className="container">
                <div className="section">
                    <div className="columns">
                        <div className="column is-10 is-offset-1">
                            <div className="content">
                                <h2 className="has-text-weight-semibold is-size-2">
                                    {pricing.heading}
                                </h2>
                                <p className="is-size-5">{pricing.description}</p>
                                <Pricing data={pricing.plans}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
);

PricingPageTemplate.propTypes = {
    title: PropTypes.string,
    meta_title: PropTypes.string,
    meta_description: PropTypes.string,
    pricing: PropTypes.shape({
        heading: PropTypes.string,
        description: PropTypes.string,
        plans: PropTypes.array,
    }),
};

const PricingPage = ({data}) => {
    const {frontmatter} = data.markdownRemark;

    return (
        <PricingPageTemplate
            title={frontmatter.title}
            meta_title={frontmatter.meta_title}
            meta_description={frontmatter.meta_description}
            pricing={frontmatter.pricing}
        />
    )
};

PricingPage.propTypes = {
    data: PropTypes.shape({
        markdownRemark: PropTypes.shape({
            frontmatter: PropTypes.object,
        }),
    }),
};

export default PricingPage;

export const pricingPageQuery = graphql`
  query PricingPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        meta_title
        meta_description
        pricing {
          heading
          description
          plans {
            description
            items
            plan
            price
          }
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/templates/pricing-page.js